import { apiReturnResults } from '@app/client/apiFactory/apiReturn';

import { type ApiResult, type BaseParams, type PostParams, Request } from '../../common';
import {
    type EmojiId,
    type TagQuery,
    type TagResponse,
    type UpdateTagsRequest,
} from '../../common/structs/emoji/emoji';
import { links } from '../../links';
//List

export type GetEmojiTagsParams = BaseParams<TagQuery> & { eid: string };
export type UpdateEmojiTagsParams = BaseParams & PostParams<UpdateTagsRequest> & { eid: string };
export async function getCollection(params: GetEmojiTagsParams): Promise<ApiResult<TagResponse>> {
    return Request.getRequest<TagResponse>({
        ...params,
        target: links.emoji().tags(encodeURIComponent(params.eid)).collection(),
    });
}

// Store
export async function update(params: UpdateEmojiTagsParams): Promise<ApiResult<EmojiId>> {
    return Request.patchRequest<EmojiId>({
        ...params,
        target: links.emoji().tags(encodeURIComponent(params.eid)).collection(),
        settings: {
            ...params.settings,
        },
    });
}
// Delete
export async function remove(
    params: BaseParams & PostParams<UpdateTagsRequest> & { eid: string },
): Promise<ApiResult<EmojiId>> {
    delete params.value.insert;
    return Request.patchRequest<EmojiId>({
        ...params,
        target: links.emoji().tags(encodeURIComponent(params.eid)).collection(),
        settings: {
            ...params.settings,
        },
    });
}

export const callGetEmojiTags = (params: GetEmojiTagsParams) => apiReturnResults<TagResponse>(getCollection, params);
export const callUpdateEmojiTags = (params: UpdateEmojiTagsParams) => apiReturnResults<EmojiId>(update, params);
export const callDeleteEmojiTag = (params: UpdateEmojiTagsParams) => apiReturnResults<EmojiId>(remove, params);
